import { GuaranteeDto } from "api/pricing";

// Configuration des dépendances entre garanties
export interface GuaranteeDependency {
  name: string;
  dependencies: string[]; // Garanties requises pour que cette garantie soit disponible
}

export const guaranteeDependenciesConfig: GuaranteeDependency[] = [
  {
    name: "ITT",
    dependencies: [] // ITT est sélectionnable seule
  },
  {
    name: "IPT",
    dependencies: ["ITT"] // IPT nécessite ITT
  },
  {
    name: "IPP",
    dependencies: ["ITT", "IPT"] // IPP nécessite ITT et IPT
  }
];

// Utilitaire pour vérifier si une garantie est disponible
export const isGuaranteeAvailable = (
  guaranteeName: string,
  activeGuarantees: string[],
  allGuarantees: GuaranteeDto[]
): boolean => {
  const dependencyConfig = guaranteeDependenciesConfig.find(
    config => config.name === guaranteeName
  );

  if (!dependencyConfig) {
    // Si pas de configuration de dépendance, la garantie est disponible par défaut
    return true;
  }

  // Vérifier que toutes les dépendances sont actives
  return dependencyConfig.dependencies.every(depName => {
    const depGuarantee = allGuarantees.find(g => g.name === depName);
    return depGuarantee && activeGuarantees.includes(depGuarantee.id);
  });
};

// Utilitaire pour obtenir les dépendances manquantes d'une garantie
export const getMissingDependencies = (
  guaranteeName: string,
  activeGuarantees: string[],
  allGuarantees: GuaranteeDto[]
): string[] => {
  const dependencyConfig = guaranteeDependenciesConfig.find(
    config => config.name === guaranteeName
  );

  if (!dependencyConfig) {
    return [];
  }

  const missingDeps: string[] = [];

  dependencyConfig.dependencies.forEach(depName => {
    const depGuarantee = allGuarantees.find(g => g.name === depName);
    if (!depGuarantee || !activeGuarantees.includes(depGuarantee.id)) {
      missingDeps.push(depName);
    }
  });

  return missingDeps;
};
export const getGuaranteesToDeactivate = (
  guaranteeToDeactivate: string,
  activeGuarantees: string[],
  allGuarantees: GuaranteeDto[]
): string[] => {
  const guaranteeToDeactivateData = allGuarantees.find(g => g.id === guaranteeToDeactivate);
  if (!guaranteeToDeactivateData) return [];

  const guaranteesToDeactivate: string[] = [];

  // Trouver toutes les garanties qui dépendent de celle qu'on veut désactiver
  guaranteeDependenciesConfig.forEach(config => {
    if (config.dependencies.includes(guaranteeToDeactivateData.name)) {
      const dependentGuarantee = allGuarantees.find(g => g.name === config.name);
      if (dependentGuarantee && activeGuarantees.includes(dependentGuarantee.id)) {
        guaranteesToDeactivate.push(dependentGuarantee.id);
        // Récursivement chercher les garanties qui dépendent de celle-ci
        guaranteesToDeactivate.push(
          ...getGuaranteesToDeactivate(dependentGuarantee.id, activeGuarantees, allGuarantees)
        );
      }
    }
  });

  return Array.from(new Set(guaranteesToDeactivate)); // Supprimer les doublons
};;
